import GuidelinesTypes from './guidelinesTypes';

export const isErrorCodes =
  (guidelines: any): guidelines is GuidelinesTypes.ErrorCodes => (
    (guidelines as any)?.errorCodes?.length > 0
  );

export const isGuidelines =
  (guidelines: any): guidelines is GuidelinesTypes.Guidelines => (
    (guidelines as any)?.guidelines?.length > 0
  );
